import { AuthenticationScheme } from '@see-power-pft-common-js/auth/enums';
import { HTTP_STATUS } from 'common-react/constants/http-status';

export const redirectToCipm3Login = () => {
  const url = new URL(`${import.meta.env.VITE_CIPM3_URL}/authorize`);
  const params = url.searchParams;

  params.set('redirect_uri', import.meta.env.VITE_CIPM3_REDIRECT_URI);
  params.set('client_id', import.meta.env.VITE_CIPM3_CLIENT_ID);
  params.set('response_type', import.meta.env.VITE_CIPM3_RESPONSE_TYPE);
  params.set('state', import.meta.env.VITE_CIPM3_STATE);
  params.set('scope', import.meta.env.VITE_CIPM3_SCOPE);
  params.set('prompt', import.meta.env.VITE_CIPM3_PROMPT);
  params.set('access_type', import.meta.env.VITE_CIPM3_ACCESS_TYPE);
  params.set('nonce', import.meta.env.VITE_CIPM3_NONCE);
  params.set('ui_locales', import.meta.env.VITE_CIPM3_UI_LOCALES);
  params.set('code_challenge', import.meta.env.VITE_CIPM3_CODE_CHALLENGE);
  params.set(
    'code_challenge_method',
    import.meta.env.VITE_CIPM3_CODE_CHALLENGE_METHOD,
  );

  window.location.href = url.toString();
};

export const redirectToCipm3Logout = () => {
  window.location.href = `${
    import.meta.env.VITE_CIPM3_URL
  }/endsession?client_id=${
    import.meta.env.VITE_CIPM3_CLIENT_ID
  }&post_logout_redirect_uri=${encodeURIComponent(import.meta.env.VITE_CIPM3_REDIRECT_URI)}`;
};

export const redirectToCipm3Profile = (onOpenPersonalDetails: () => void) => {
  onOpenPersonalDetails();

  const backRedirectionState = encodeURIComponent(
    new URL(document.location.toString()).pathname.replace('/', ''),
  );

  const backRedirectionUri = `${import.meta.env.VITE_CIPM3_REDIRECT_URI}`;

  const url = new URL(`${import.meta.env.VITE_CIPM3_URL}/personal-details`);
  const params = url.searchParams;

  params.set('client_id', import.meta.env.VITE_CIPM3_CLIENT_ID);
  params.set('redirect_uri', backRedirectionUri);
  params.set('response_type', import.meta.env.VITE_CIPM3_RESPONSE_TYPE);
  params.set('state', backRedirectionState);
  params.set('scope', import.meta.env.VITE_CIPM3_SCOPE);

  window.location.href = url.toString();
};

export const redirectToCipm3ChangePassword = (
  onOpenChangePassword: () => void,
) => {
  onOpenChangePassword();

  const backRedirectionState = encodeURIComponent(
    new URL(document.location.toString()).pathname.replace('/', ''),
  );

  const backRedirectionUri = `${import.meta.env.VITE_CIPM3_REDIRECT_URI}`;

  const url = new URL(`${import.meta.env.VITE_CIPM3_URL}/change-password`);
  const params = url.searchParams;

  params.set('client_id', import.meta.env.VITE_CIPM3_CLIENT_ID);
  params.set('redirect_uri', backRedirectionUri);
  params.set('response_type', import.meta.env.VITE_CIPM3_RESPONSE_TYPE);
  params.set('state', backRedirectionState);
  params.set('scope', import.meta.env.VITE_CIPM3_SCOPE);

  window.location.href = url.toString();
};

export const getCipm3SchemeAuthenticationJwtTokenUsingAuthorizationCode =
  async (authorizationCode: string) => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_PLUTO_API_ENDPOINT}/authentication/token`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            scheme: AuthenticationScheme.CIPM3,
            'auth-code': authorizationCode,
          }),
        },
      );

      if (response.status === HTTP_STATUS.UNAUTHORIZED) {
        return;
      }

      if (response.ok) {
        return await response.text();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);

      return;
    }
  };

export const getCipm3SchemeAuthenticationJwtTokenUsingRefreshToken = async (
  refreshToken: string,
) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_PLUTO_API_ENDPOINT}/authentication/token`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          scheme: AuthenticationScheme.CIPM3,
          'refresh-token': refreshToken,
        }),
      },
    );
    if (response.status === HTTP_STATUS.UNAUTHORIZED) {
      return;
    }

    if (response.ok) {
      return await response.text();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    return;
  }
};
